module.exports = __webpack_public_path__ + "static/media/footer-mail.1deba868.svg";